import { render } from "./OcrItemListAction.vue?vue&type=template&id=5135d166&scoped=true"
import script from "./OcrItemListAction.vue?vue&type=script&lang=js"
export * from "./OcrItemListAction.vue?vue&type=script&lang=js"

import "./OcrItemListAction.vue?vue&type=style&index=0&id=5135d166&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5135d166"]])

export default __exports__